var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExerciseWeightLoss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#2A384F;}\n\t.st2{fill:#F8EEE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,137.2c-11.1,0-20.1-9-20.1-20.1c0-11.1,9-20.1,20.1-20.1c11.1,0,20.1,9,20.1,20.1 C89.2,128.2,80.2,137.2,69.1,137.2z M69.1,101c-8.9,0-16.2,7.2-16.2,16.2c0,8.9,7.2,16.2,16.2,16.2c8.9,0,16.2-7.2,16.2-16.2 C85.3,108.2,78,101,69.1,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.8,137.2c-11.1,0-20.1-9-20.1-20.1c0-11.1,9-20.1,20.1-20.1c11.1,0,20.1,9,20.1,20.1 C160.9,128.2,151.9,137.2,140.8,137.2z M140.8,101c-8.9,0-16.2,7.2-16.2,16.2c0,8.9,7.2,16.2,16.2,16.2c8.9,0,16.2-7.2,16.2-16.2 C157,108.2,149.7,101,140.8,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.4,83.5c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3h-14.8 c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6.6c-1.7,3.6-2.6,7.3-3,10.8H89.8L84.4,78c-0.5-0.9-1.7-1.3-2.7-0.7C80.8,77.8,80.4,79,81,80 l5.3,9.4L67.5,116c-0.4,0.6-0.5,1.4-0.1,2c0.3,0.7,1,1.1,1.7,1.1h35.1c0.3,0,0.6-0.1,0.8-0.2c0,0,0.1,0,0.1,0 c0.2-0.1,0.5-0.3,0.6-0.5c0,0,0,0,0.1-0.1l19.5-26.8h4.9c0.2,14.3,8.6,26.1,9.1,26.8c0.4,0.5,1,0.8,1.6,0.8c0.4,0,0.8-0.1,1.2-0.4 c0.9-0.6,1.1-1.9,0.4-2.7c-0.2-0.2-14.9-20.8-4.8-39.2h3.8c1.9,0,3.4,1.5,3.4,3.4C144.8,82,143.3,83.5,141.4,83.5z M72.9,115.2 l15.5-22l12.4,22H72.9z M104.4,113.5L92,91.5h28.4L104.4,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,81.2c-8.1,0-13-2.6-13.2-2.7c-1-0.5-1.3-1.7-0.8-2.7c0.5-0.9,1.7-1.3,2.7-0.8c0.1,0,5.9,3.1,15.2,2 c1.1-0.1,2,0.7,2.2,1.7c0.1,1.1-0.7,2-1.7,2.2C90,81.1,88.6,81.2,87.2,81.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseWeightLoss);
export default __webpack_public_path__ + "static/media/Exercise_WeightLoss.ea2600d7c1f0e2c2a58924ea163b494e.svg";
export { ForwardRef as ReactComponent };